"use client";

import React, { useState } from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useOutletContext } from "react-router-dom";

export const FAQS = [
  {
    q: "Why have coworking spaces become so popular in India?",
    a: "Coworking spaces give teams flexibility, lower overheads and instant access to a professional community — ideal for hybrid and startup work. India's flexible office stock grew over 25% year-on-year across the top 7 cities since 2021, driven by startups and enterprises decentralising. At The Hive, teams can start with 4 seats and scale to 150+ seats across 12+ centers without fit-out cost or a 3-year lock-in."
  },
  {
    q: "How does The Hive compare to traditional office rentals?",
    a: "The Hive provides plug-and-play infrastructure — furnished offices, high-speed internet, meeting rooms and front-desk support — included in one monthly fee. Traditional leases typically require 6–12 months' deposit, 3–5 year commitments and separate vendor contracts for interiors, IT and housekeeping. Members can expand within the same building in days, avoiding the hidden 15–25% overhead of a conventional lease."
  },
  {
    q: "What key features make a coworking space truly successful?",
    a: "Successful spaces combine flexible layouts (hot desks, dedicated desks, private cabins, enterprise floors), enterprise-grade amenities and an active community program. The Hive maintains 99.9% power uptime, 200 Mbps+ internet and ergonomic work zones across Chennai, Bangalore, Hyderabad, Pune, Mumbai, Delhi NCR and Noida. Community managers curate weekly networking, workshops and inter-company referrals that turn proximity into business opportunities."
  },
  {
    q: "Why are coworking spaces a smart choice for startups?",
    a: "Startups avoid upfront capex — no fit-out, furniture or 3-year lease — and can scale seats month-to-month as hiring changes. A ready-to-work office with boardrooms and investor-ready meeting rooms establishes credibility from day one without facilities management overhead. At The Hive, early-stage teams also plug into mentors, hiring pools and enterprise clients co-located across 12+ prime business districts."
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();
  const { theme } = useOutletContext();

  return (
    <section
      className={`py-4 ${theme === "dark" ? "bg-black text-white" : "bg-white text-black"
        }`}
    >
      <div className="max-w-[90%] mx-auto px-4 py-4 grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Left title */}
        <div>
          <p
            className={`text-sm mb-2 ${theme === "dark" ? "text-gray-400" : "text-gray-500"
              }`}
          >
            / FAQ /
          </p>

          <h2
            className={`text-4xl md:text-5xl liber leading-tight ${theme === "dark" ? "text-white" : "text-black"
              }`}
          >
            Frequently Asked <br /> Questions
          </h2>
        </div>

        {/* Right FAQ items */}
        <div className="md:col-span-2  space-y-4">

          {FAQS.map((item, idx) => {
            const isOpen = openIndex === idx;

            return (
              <div
                key={idx}
                className={`rounded-md shadow-sm overflow-hidden transition ${theme === "dark"
                  ? "bg-white/5 border border-white/10"
                  : "bg-white border border-black/10"
                  }`}
              >
                <button
                  className="w-full flex justify-between items-center px-6 py-4 text-left cursor-pointer"
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                >
                  <span
                    className={`font-medium ${theme === "dark" ? "text-white" : "text-gray-800"
                      }`}
                  >
                    {item.q}
                  </span>

                  <motion.div
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <ChevronDown
                      className={`w-5 h-5 ${theme === "dark" ? "text-gray-300" : "text-gray-500"
                        }`}
                    />
                  </motion.div>
                </button>

                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div
                        className={`px-6 pb-4 text-sm ${theme === "dark" ? "text-gray-300" : "text-gray-600"
                          }`}
                      >
                        {item.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}

          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => navigate("/support/faq")}
              className={`
            inline-flex items-center justify-center px-6 py-2 text-sm font-semibold transition-all duration-200
            ${theme === "dark"
                  ? "text-black bg-white hover:bg-gradient-to-br hover:from-goldt hover:via-gold hover:to-goldt hover:text-black"
                  : "bg-gradient-to-br from-goldt via-gold to-goldt text-black hover:bg-black "
                }
          `}
            >
              View all <ArrowRight size={16} className="ml-2" />
            </button></div>

          {/* View More Button */}
          {/* <div className="text-center pt-6 flex justify-end">
            <button
              onClick={() => {
                navigate("/support/faq");
              }}
              className={`
                flex items-center cursor-pointer px-4 py-2 font-semibold text-sm  transition
                ${
              theme === "dark"
                ? "text-black bg-white hover:bg-gradient-to-br hover:from-goldt hover:via-gold hover:to-goldt hover:text-black"
                : "bg-gradient-to-br from-goldt via-gold to-goldt text-black hover:bg-black "
            }
              `}
            >
              View More <ArrowRight className="ml-2" size={18} />
            </button>
          </div> */}
        </div>
      </div>
    </section>
  );
}
